import { devtools } from 'zustand/middleware';

export const devtoolsInNonProd = (process.env.NODE_ENV === 'production'
  ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fn: any) => fn
  : devtools) as unknown as typeof devtools;
